import Cookies from 'js-cookie'

import { getAuthCookieName } from '@/services/cookies'

export function getAuthSession() {
  return Cookies.get(getAuthCookieName()) ?? null
}

export function setAuthSession(token: string) {
  Cookies.set(getAuthCookieName(), token, { expires: 7 })
}

export function clearAuthSession() {
  Cookies.remove(getAuthCookieName())
}
